import {
  Component,
  ElementRef,
  Input,
  OnInit,
  SimpleChanges,
  viewChild
} from '@angular/core';

import { SocialMediaFileTypes } from 'src/app/core/api/models';
import { ConsoleService } from 'src/app/core/services/console.service';

@Component({
    selector: 'app-file-controller',
    templateUrl: './file-controller.component.html',
    styleUrls: ['./file-controller.component.scss'],
    standalone: false
})
export class FileControllerComponent implements OnInit {
  readonly fileController = viewChild<ElementRef<any>>('fileController');
  @Input() fileSrc: string;
  @Input() fileId: number;
  @Input() fileType: SocialMediaFileTypes;
  @Input() palyAgain: boolean;
  @Input() isShowTime: boolean = true;
  @Input() pauseAllFile: boolean = true;
  @Input() smallSize: boolean = false;
  @Input() fileWidth: string = '100%';
  loading: boolean = true;

  get FileType() {
    return SocialMediaFileTypes;
  }

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.fileSrc) this.loading = false;
    const timeOut = setTimeout(() => {
      this.updateFileController();
      clearTimeout(timeOut);
    }, 100);
  }

  updateFileController() {
    try {
      const fileController = this.fileController();
      if (!this.fileSrc?.trim() || !fileController) return;

      if (this.pauseAllFile) this.getAllFileELements();

      fileController.nativeElement.pause();
      fileController.nativeElement.setAttribute('src', this.fileSrc);
      fileController.nativeElement.load();
    } catch (error) {
      ConsoleService.error('error', error);
    }
  }

  getAllFileELements() {
    const fileElements = document.querySelectorAll('file');
    fileElements.forEach((el: any) => {
      if (el != this.fileController().nativeElement) el?.pause();
    });
  }

  onPlay(event) {
    if (this.pauseAllFile) this.getAllFileELements();
  }
}
